export const faqsPl = [
  {
    q: "Czym są warsztaty produktowe przed budową MVP?",
    a: "To krótkie, intensywne spotkania discovery: mapujemy użytkowników, user stories, ryzyka i zakres MVP. Na wyjściu dostajesz materiały do wyceny — nie tylko „spotkanie o pomyśle”.",
  },
  {
    q: "Kiedy warsztaty mają sens, a kiedy wystarczy brief?",
    a: "Jeśli masz jasny zakres, Figmę i listę funkcji — często wystarczy konsultacja i wycena. Warsztaty warto zrobić, gdy brief jest niepełny, budżet jest twardy, albo nie wiadomo jeszcze, czy to appka, SaaS czy urządzenie.",
  },
  {
    q: "Ile trwają warsztaty produktowe?",
    a: "Typowo 1–3 dni robocze (zdalnie lub hybrydowo), czasem rozłożone na kilka sesji po 2–3 godziny. Cel: domknąć zakres MVP i ryzyka przed wyceną developmentu.",
  },
  {
    q: "Co dostaję po warsztatach?",
    a: "Zakres MVP z kryteriami sukcesu, priorytetyzowane user stories, ryzyka techniczne i produktowe, propozycję stacku oraz materiały pod wycenę (często z makietami low-fi). To baza do oferty ze stałą ceną albo planu Time & Material.",
  },
  {
    q: "Czy warsztaty pomagają przygotować brief do wyceny?",
    a: "Tak — to ich główny cel. Jeśli nie wiesz, jak wycenić projekt na podstawie briefu albo jak ten brief w ogóle przygotować, warsztaty domykają lukę między pomysłem a ofertą wykonawcy.",
  },
  {
    q: "Czy robicie warsztaty dla produktów hardware / IoT?",
    a: "Tak. Przy urządzeniu mapujemy też elektronikę, firmware, łączność i ścieżkę PoC → MVP → produkcja. Często wychodzi, że pierwszy krok to DevKit, nie od razu własna PCB.",
  },
  {
    q: "Ile kosztują warsztaty produktowe?",
    a: "Zależnie od zakresu: zwykle od kilku do kilkunastu tysięcy złotych. To ułamek kosztu MVP, a oszczędza drogie przeróbki zakresu w trakcie developmentu. Orientacyjne widełki całego MVP znajdziesz na stronie cennika.",
  },
  {
    q: "Czy po warsztatach muszę budować MVP z Wami?",
    a: "Nie. Materiały są Wasze — możecie iść do innego wykonawcy albo zespołu in-house. W praktyce wielu klientów zostaje, bo zakres i wycena są już zsynchronizowane.",
  },
] as const;
